export function updateCityInUserProfile(){
    const payload = {};
    payload.city = JSON.parse(localStorage.getItem("currentCity")).uuid;
    api.setUserProfileInfo(payload).then(()=>{
    }).catch((error)=>{
    });
}